<app-header></app-header>
<ion-content>
  <app-browse-title
    *ngIf="platformService.platformType === platformService?.platformEnum?.desktop"
  >
  </app-browse-title>
  <div class="browse-sub-category-container">
    <div class="main-browse-sub-category-content">
      <div
        class="browse-sub-category-bread-crumbs"
        *ngIf="platformService.platformType === platformService?.platformEnum?.desktop"
      >
        <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
      </div>
      <div class="browse-sub-category-title-view-all-products">
        <span class="browse-sub-category-title">{{ classDescription }}</span>
        <ion-button
          class="usf-green-link-button view-all-categories-button"
          (click)="viewCategory(classCode, EndecaSearchPagesTypes.all, classDescription)"
          >{{ 'i18n.search.searchCatalogPage.viewAll' | translate}}</ion-button
        >
      </div>
      <div class="browse-sub-category-items">
        <ion-card
          (click)="viewCategory(subCategory?.categoryCode, EndecaSearchPagesTypes.catalog, classDescription+'+'+subCategory.categoryDescription)"
          *ngFor="let subCategory of subCategories; let index = index"
        >
          <img
            [src]="baseCategoryImageUri + subCategory?.categoryCode + '.jpg'"
          />
          <div class="browse-sub-category-card-description">
            <div>{{ subCategory?.categoryDescription | titlecase }}</div>
          </div>
        </ion-card>
      </div>
    </div>
  </div>
  <app-footer
    *ngIf="platformService.platformType === platformService?.platformEnum?.desktop"
  ></app-footer>
</ion-content>
